import PromoFormSelected from './PromoFormSelected';

export default PromoFormSelected;